import { keyBy } from 'lodash';

import {
  GET_PACKAGES,
  GET_PACKAGES_FAILED,
  GET_PACKAGES_SUCCESS,
} from "../actions/packageManagement.action";

const INITIAL_STATE = {
  packages: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function packageReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PACKAGES:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_PACKAGES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        packages: {
          ...payload,
          data: keyBy(payload.data, '_id'),
        },
      });
    case GET_PACKAGES_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
